module.exports = __webpack_public_path__ + "static/media/SingleCoupon_instructionTitle.6521ffee.png";